(function() {
	document.addEventListener("DOMContentLoaded", function() {
		var noMileage = document.getElementById("notActualMileage");
		var isMileage = document.getElementById("isActualMileage");

		if(noMileage && isMileage) {
			noMileage.addEventListener("click", function() {
				if(this.checked) isMileageRequired(false);
			});

			isMileage.addEventListener("click", function() {
				if(this.checked) isMileageRequired(true);
			});
		}

		function isMileageRequired(flag) {
			var mileage  = document.querySelector("input[name='miles']");
			var errorMsg = document.getElementById("miles-error");

			var requiredClass = "requiredTextField";

			if(mileage instanceof HTMLElement) {
				setTimeout(() => {
					mileage.required = flag;
					mileage.setAttribute("aria-required", flag);

					if(flag === false && errorMsg) {
						errorMsg.textContent   = "";
						errorMsg.style.display = "none";
					}

					// edit page
					if(flag) mileage.classList.add(requiredClass);
					else mileage.classList.remove(requiredClass);
				}, 0);
			}
		}
	});
})();